module.exports = __webpack_public_path__ + "img/necromancer_small.9305d49c.png";